"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var React = __importStar(require("react"));
var react_number_format_1 = __importDefault(require("react-number-format"));
var material_1 = require("../../styles/material");
var NumberFormatCustom = function (props) {
    var inputRef = props.inputRef, onChange = props.onChange, allowNegative = props.allowNegative, allowDecimal = props.allowDecimal, other = __rest(props, ["inputRef", "onChange", "allowNegative", "allowDecimal"]);
    var defaultDecimalScale = 3;
    return (React.createElement(react_number_format_1.default, __assign({}, other, { getInputRef: inputRef, onValueChange: function (values) {
            onChange({
                target: {
                    value: values.value
                }
            });
        }, allowNegative: allowNegative, thousandSeparator: true, decimalScale: allowDecimal ? defaultDecimalScale : 0, isNumericString: true })));
};
exports.CurrencyInput = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, defaultValue = _a.defaultValue, placeholder = _a.placeholder, allowNegative = _a.allowNegative, allowDecimal = _a.allowDecimal, onChange = _a.onChange, onBlur = _a.onBlur, restProps = __rest(_a, ["name", "label", "value", "defaultValue", "placeholder", "allowNegative", "allowDecimal", "onChange", "onBlur"]);
    return (React.createElement(core_1.ThemeProvider, { theme: material_1.theme },
        React.createElement(TextField_1.default, __assign({ name: name, label: label, value: value, defaultValue: defaultValue, placeholder: placeholder, onChange: function (event) {
                if (!!onChange)
                    onChange(event.target.value);
            }, onBlur: function (event) {
                if (!!onBlur)
                    onBlur(event.target.value);
            }, fullWidth: true, InputProps: {
                startAdornment: React.createElement(core_1.InputAdornment, { position: 'start' }, "$"),
                inputComponent: NumberFormatCustom,
                inputProps: { allowNegative: (allowNegative !== null && allowNegative !== void 0 ? allowNegative : false), allowDecimal: (allowDecimal !== null && allowDecimal !== void 0 ? allowDecimal : false) }
            } }, restProps))));
};
//# sourceMappingURL=CurrencyInput.js.map